const testimonials = [
  {
    name: "Thomas K.",
    location: "Union Pacific, Texarkana",
    rating: 5,
    text: "Got called to a railroad safety training program in Calgary with three weeks notice. My passport had been expired for two years. Fast Passport Center had my renewal submitted through their courier access and delivered back to me in eight business days. I made the training on time. The whole thing was done entirely by mail — no office visits, no driving to Little Rock. Exactly what a busy railroad professional needs.",
    service: "Passport Renewal",
  },
  {
    name: "Jessica M.",
    location: "Texarkana College, Texarkana",
    rating: 5,
    text: "I was accepted to a summer study program in Mexico City and had never had a passport. Fast Passport Center told me exactly which Texarkana acceptance facility to visit, what forms to bring, how to get my photo taken — the whole thing. Six weeks later I was on a plane. I had been stressed about the process for weeks before I found them and they made it completely manageable.",
    service: "New Passport",
  },
  {
    name: "Rev. Michael & Team",
    location: "Miller County Church, Texarkana",
    rating: 5,
    text: "We had three team members with no passports and a departure date to Honduras in five weeks. I was not sure it was even possible. Fast Passport Center handled every one of them — walked them through the clerk process, reviewed the documents, and got all three passports delivered with ten days to spare before our mission trip. Our team arrived complete. Cannot thank them enough.",
    service: "Mission Team Passports",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function TexarkanaTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Ark-La-Tex Travelers Say About Our Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Texarkana, Miller County, and Bowie County travelers who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col">
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}